export default "__VITE_ASSET__BCyQaloB__"